import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const RandMBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="R & M"
      sectionDisplayName="R & M Section"
      backRoute="/sections/r-and-m"
    />
  );
};

export default RandMBundleReceiptEntry;
